import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HCBoost from "highcharts/modules/boost";
import HCDataGrouping from "highcharts/modules/data";
import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../../context/AuthProvider";

// Initialize data grouping module
HCDataGrouping(Highcharts);
HCBoost(Highcharts);

const ColumnChart = ({
  actual = [
    78, 44, 61, 96, 66, 22, 36, 38, 52, 47, 25, 54, 16, 87, 83, 34, 52, 51, 87,
    95, 67, 73, 21, 82, 51, 39, 18, 63, 26, 67,
  ],
  predicted = [
    19, 38, 61, 17, 65, 68, 78, 81, 44, 33, 67, 88, 47, 64, 34, 45, 97, 39, 48,
    46, 71, 65, 93, 59, 78, 47, 81, 42, 70, 89,
  ],
  categories = [
    30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48,
    49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
  ],
  factorName = "",
}) => {
  const [state, setState] = useState(null);
  const { QCFull } = useAuthContext();

  function getIndicesMultiple(array) {
    const count = Math.floor(array.length / 10);

    if (array?.length < 30) return array.map((_, index) => index);
    
    return array
      .map((_, index) => index)
      .filter((index) => index % count === 0);
  }
  const timezoneOffset = new Date().getTimezoneOffset();
  useEffect(() => {
    setState({
      chart: {
        type: "column",
        zoomType: "x",
        height: QCFull
          ? window.screen.height - window.screen.height / 3
          : window.screen.height - window.screen.height / 2.1 || "450px",
      },
      title: {
        text: "Probability Density Function and stacked Histograms",
        align: "center",
        floating: false,
        margin: 15,
        style: {
          color: "#404040",
          fontSize: "15px",
          fontWeight: "500",
          fontFamily: "Montserrat, sans-serif",
        },
        useHTML: false,
        verticalAlign: undefined,
        widthAdjust: -44,
      },
      series: [
        {
          data: actual,
          type: "column",
          name: ` ${factorName} (Scrapped=1)`,
          color: "#0077b6",
          lineWidth: 1,
          marker: {
            enabled: true,
            radius: 1.5,
          },
          showInLegend: true,
          turboThreshold: Infinity,
        },
        {
          data: predicted,
          type: "column",
          name: ` ${factorName} (Scrapped=0)`,
          color: "#EA8600",
          lineWidth: 1,
          marker: {
            enabled: true,
            radius: 1.5,
          },
          showInLegend: true,
          turboThreshold: Infinity,
        },
      ],
      legend: {
        align: "right",
        verticalAlign: "top",
        layout: "horizontal",
        alignColumns: false,
        itemStyle: {
          fontSize: "11px",
          fontWeight: "600",
        },
      },
      tooltip: {
        valueSuffix: "",
        shared: true,
        crosshair: true,
        style: {
          fontSize: "11px",
          fontWeight: "600",
        },
      },
      boost: {
        seriesThreshold: 100000,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        series: {
          dataGrouping: {
            enabled: true,
            approximation: "average", // Choose appropriate aggregation function
            groupPixelWidth: 10, // Adjust based on your data density
          },
        },
      },
      time: {
        timezoneOffset: timezoneOffset,
      },
      xAxis: {
        categories: categories,
        crosshair: {
          width: 1,
          color: "#e4e4e4",
          dashStyle: "Solid",
        },
        title: {
          enabled: true,
          text: "Value",
        },
        tickPositions: getIndicesMultiple(categories),
        labels: {
          style: {
            color: "#404040",
            fontSize: "10px",
            fontWeight: "600",
          },
        },
      },
      yAxis: {
        title: {
          text: "Probability Density / Count",
        },
        labels: {
          format: "{text}",
          style: {
            color: "#404040",
            fontSize: "10px",
            fontWeight: "600",
          },
        },
      },
    });
  }, [window.screen.height, QCFull, categories]);

  if (!actual) {
    return null; // or render a loading indicator
  }

  return (
    <div id="chart" style={{ borderRadius: "16px" }}>
      <HighchartsReact highcharts={Highcharts} options={state} />
    </div>
  );
};
export default ColumnChart;
